import { Outlet } from "react-router-dom";
import Teach_attributes from "./tutoring_attributes";
import TopNavbar from "../components/TopNavbar";

const Tutoring = ( ) => {
 
  
    return (
        <div>
    <TopNavbar />
    <Teach_attributes />   

     <Outlet/>      
    </div>
  );
};
 
export default Tutoring;